import React from 'react';
import './Stats.css';
import Separator from '../Separator';

const Stats = () => (
  <div className="stats">
    <div className="stats-item">
      <h1>4500<span className="stats-gray">+</span></h1>
      <h3>ATTENDEES</h3>
    </div>
    <Separator className="stats-separator" />
    <div className="stats-item">
      <h1>350<span className="stats-gray">+</span></h1>
      <h3>SPEAKERS</h3>
    </div>
    <Separator className="stats-separator" />
    <div className="stats-item">
      <h1>150<span className="stats-gray">+</span></h1>
      <h3>AI EXHIBITS</h3>
    </div>
    <Separator className="stats-separator" />
    <div className="stats-item">
      <h1>75<span className="stats-gray">+</span></h1>
      <h3>COUNTRIES</h3>
    </div>
  </div>
)

export default Stats;
